<template>
  <div class="bg">
    <div class="index">
      <div class="index_top">
        <img
          src="../assets/logo.png"
          alt=""
        >
        <div
          v-if="userFlag==false"
          class="button"
          @click="login()"
        >登录/注册</div>
        <div
          v-else
          class="user_info"
        ><span @click="toCenter()">
            <el-avatar icon="el-icon-user-solid" title="个人中心"></el-avatar>
          </span>
          <el-select
            v-model="value"
            placeholder=""
            @change="changeUser"
          >
            <el-option :value="userObj.phone">{{userObj.phone}}</el-option>
            <el-option value=""><i class="el-icon-s-home"></i> 退出</el-option>
          </el-select>
        </div>
      </div>
      <div class="index_center">
        爱普适，专注于物联网解决方案
      </div>
      <div class="bottom">
        <div>
          <div
            @click="changeSearch('')"
            :class="{'clicked':(searchIndex=='')}"
          >全部</div>
          <div
            @click="changeSearch(1)"
            :class="{'clicked':(searchIndex==1)}"
          >演示系统</div>
          <div
            @click="changeSearch(2)"
            :class="{'clicked':(searchIndex==2)}"
          >设计方案</div>
          <div
            @click="changeSearch(3)"
            :class="{'clicked':(searchIndex==3)}"
          >宣传画册</div>
          <div
            @click="changeSearch(4)"
            :class="{'clicked':(searchIndex==4)}"
          >演示视频</div>
          <div
            @click="changeSearch(5)"
            :class="{'clicked':(searchIndex==5)}"
          >其他</div>
        </div>
        <div>
          <el-input v-model="searchForm.systemName"></el-input>
          <el-button @click="searchTo()">搜索</el-button>
        </div>
        <div>
          <div><span>@</span>热搜关键词：</div>
          <div
            v-for="item in hotList"
            :key="item.id"
            @click="hotClick(item.flagId)"
          >{{item.hotWordsName}}</div>
        </div>

      </div>

    </div>
    <div class="botnav">
      <div @click="goRouter('systemDemo')">
        <img
          src="../assets/logo1.png"
          alt=""
        >
        <div>
          <p>演示系统</p>
          <div class="p_box">
            <p
              @click.stop="goInfo(item)"
              v-for="item in searchList1"
              :key="item.id"
            >{{item.systemName}}</p>
          </div>
        </div>
      </div>
      <div @click="goRouter('designScheme')">
        <img
          src="../assets/logo2.png"
          alt=""
        >
        <div>
          <p>设计方案</p>
          <div class="p_box">
            <p
              @click.stop="goInfo(item)"
              v-for="item in searchList2"
              :key="item.id"
            >{{item.systemName}}</p>
          </div>
        </div>
      </div>
      <div @click="goRouter('publicPictures')">
        <img
          src="../assets/logo3.png"
          alt=""
        >
        <div>
          <p>宣传画册</p>
          <div class="p_box">
            <p
              @click.stop="goInfo(item)"
              v-for="item in searchList3"
              :key="item.id"
            >{{item.systemName}}</p>
          </div>
        </div>
      </div>
      <div @click="goRouter('videoDemo')">
        <img
          src="../assets/logo4.png"
          alt=""
        >
        <div>
          <p>演示视频</p>
          <div class="p_box">
            <p
              @click.stop="goInfo(item)"
              v-for="item in searchList4"
              :key="item.id"
            >{{item.systemName}}</p>
          </div>
        </div>
      </div>
      <div @click="goRouter('otherDemo')">
        <img
          src="../assets/logo5.png"
          alt=""
        >
        <div>
          <p>其他</p>
          <div class="p_box">
            <p
              @click.stop="goInfo(item)"
              v-for="item in searchList5"
              :key="item.id"
            >{{item.systemName}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getHotList, loginUser, logout, searchAll } from "../js/api.js";
export default {
  name: "index",
  data() {
    return {
      value: "",
      userFlag: false,
      imgData: [],
      searchIndex: "",
      input: "",
      hotList: [],
      searchList1: [],
      searchList2: [],
      searchList3: [],
      searchList4: [],
      searchList5: [],
      userObj: {},
      searchForm: {
        pageNum: 1,
        pageSize: 3,
        goodsType: "",
        systemName: "",
      },
      searchForm1: {
        pageNum: 1,
        pageSize: 3,
      },
    };
  },
  mounted() {
    this.loginUser();
    sessionStorage.setItem("routerFlag", "navPage");
    sessionStorage.setItem("flagId", "");
    sessionStorage.setItem(
      "searchForm",
      JSON.stringify({
        pageNum: 1,
        pageSize: 3,
        goodsType: "",
        systemName: "",
      })
    );
    this.getHotList();
    this.searchAll(this.searchForm1, 1);
    this.searchAll(this.searchForm1, 2);
    this.searchAll(this.searchForm1, 3);
    this.searchAll(this.searchForm1, 4);
    this.searchAll(this.searchForm1, 5);
  },
  methods: {
    toCenter() {
      sessionStorage.setItem("routerFlag", "");
       this.$router.push({ name: "myCenter" });
    },
    changeUser(e) {
      if (e == 0) {
        this.logout();
        
      }
    },
    goInfo(e) {
      sessionStorage.setItem("infoArr", JSON.stringify(e));
      this.$router.push({
        path: "/infoPage",
        query: {
          id: e.id
        },
      });
    },
    //底部列表
    async searchAll(data, type) {
      let arr = JSON.parse(JSON.stringify(data));
      arr.goodsType = type;
      let res = await searchAll(arr);
      if (res.data.code == 200) {
        if (type == 1) {
          this.searchList1 = res.data.paging.list;
        } else if (type == 2) {
          this.searchList2 = res.data.paging.list;
        } else if (type == 3) {
          this.searchList3 = res.data.paging.list;
        } else if (type == 4) {
          this.searchList4 = res.data.paging.list;
        } else if (type == 5) {
          this.searchList5 = res.data.paging.list;
        }
      }
    },
    goRouter(e) {
      sessionStorage.setItem("routerFlag", e);
      this.$router.push({ name: e , query:this.searchForm});
    },
    login() {
      if (window.platform == undefined) {
        var http = "http://103.239.204.52:16000/index";
      } else {
        var http = `http://${window.platform.ip}:${window.platform.port}/index`;
      }
      window.location.href = http;
    },
    //热词搜索跳转
    hotClick(e) {
      sessionStorage.setItem("flagId", e);
      this.$router.push({ name: "searchPage" });
    },
    //搜索跳转
    searchTo() {
      // sessionStorage.setItem("searchForm", JSON.stringify(this.searchForm));
      this.$router.push({path: "/navPage",
        query: {
          searchForm:JSON.stringify(this.searchForm)
        },
        });
    },
    changeSearch(e) {
      this.searchForm.goodsType = e;
      this.searchIndex = e;
    },
    //获取登录人信息
    async loginUser() {
      let res = await loginUser();
      if (res.data.code == 200) {
        if (res.data.data == null) {
          this.userFlag = false;
          this.userObj = {
            phone: "",
          };
        } else {
          this.userFlag = true;
          this.userObj = res.data.data;
          this.value = res.data.data.phone
          // sessionStorage.setItem("userObj", JSON.stringify(res.data.data));
          this.$store.commit("getData", res.data.data);
        }
      }
    },
    //跳转登录页
    async logout() {
      if (window.platform == undefined) {
        var http = "http://103.239.204.52:16000/";
      } else {
        var http = `http://${window.platform.ip}:${window.platform.port}/`;
      }
      this.userFlag=false
      window.sessionStorage.clear();
      window.location.href = http + "/cas/logout";
    },
    //获取目录
    async getHotList() {
      let res = await getHotList();
      if (res.data.code == 200) {
        this.hotList = res.data.data;
      }
    },
    handleClick(tab, event) {},
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.bg {
  background: url("../assets/bg.png") no-repeat;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  overflow: hidden;
  padding: 20px 0;
  position: absolute;
  min-width: 1200px;
}
.index {
  width: 1200px;
  margin: auto;
}

.index_top {
  margin-top: 20px;
  height: 40px;
  color: #fff;
  font-size: 35px;
  text-align: center;
}
.title {
  line-height: 40px;
}

.index_top img {
  float: left;
  width: auto;
  height: 40px;
  vertical-align: center;
  margin-right: 30px;
}

.button {
  width: 130px;
  float: right;
  background: #2a67e4;
  height: 35px;
  border-radius: 50px;
  text-align: center;
  line-height: 35px;
  font-size: 17px;
  cursor: pointer;
}

.user_info{
  width: 200px;
  float: right;
  display: flex;
  cursor: pointer;
}

.user_info /deep/.el-input__inner {
  background: transparent;
  border: none;
  color: #fff;
  width: 140px;
}

.index_center {
  font-size: 32px;
  padding: 0 120px;
  color: #fff;
  margin-top: 120px;
  text-align: center;
  line-height: 50px;
  margin-bottom: 60px;
  font-weight: 800;
}

.bottom {
  height: 180px;
}

.bottom > div {
  display: flex;
  width: 670px;
  margin: auto;
}

.bottom > div:first-child {
  justify-content: space-between;
  margin-bottom: 30px;
}

.bottom > div:first-child > div {
  font-size: 18px;
  background: #0b2d4f;
  padding: 5px 15px;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
}

.bottom > div:last-child {
  color: #1557e0;
  width: 500px;
  margin-top: 20px;
  font-size: 14px;
  flex-wrap: wrap;
}

.bottom > div:last-child > div {
  text-decoration: underline;
  padding: 5px 10px;
  cursor: pointer;
}

.bottom > div:last-child > div:first-child {
  text-decoration: none;
}

.bottom > div:last-child > div:first-child {
  color: #fff;
}

.bottom > div:last-child span {
  color: #1557e0;
}

.clicked {
  background: #fff !important;
  color: #0b2d4f !important;
  position: relative;
}

.clicked::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 100%);
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #fff;
}

.bottom /deep/ .el-input__inner {
  background: #0b2d4f;
  border: none;
  color: #fff;
}

.bottom /deep/ .el-button {
  background: #2160e3;
  border: none;
  color: #fff;
}

.botnav {
  width: 1300px;
  min-height: 300px;
  height: 300px;
  display: flex;
  justify-content: space-between;
  margin: auto;
  margin-top: 30px;
}

.botnav > div {
  width: 250px;
  height: 167px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-around;
  color: #fff;
  font-size: 13px;
  padding: 0 10px;
  box-sizing: border-box;
}

.botnav img {
  width: 80px;
}

.botnav > div > div p {
  width: 120px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}

.botnav > div > div > p:first-child {
  font-size: 16px;
  margin-bottom: 5px;
}

.botnav > div:first-child {
  background: url("../assets/botnav1.png");
  background-size: 100% 100%;
}

.botnav > div:nth-child(2) {
  background: url("../assets/botnav2.png");
  background-size: 100% 100%;
}

.botnav > div:nth-child(3) {
  background: url("../assets/botnav3.png");
  background-size: 100% 100%;
}

.botnav > div:nth-child(4) {
  background: url("../assets/botnav4.png");
  background-size: 100% 100%;
}

.botnav > div:nth-child(5) {
  background: url("../assets/botnav5.png");
  background-size: 100% 100%;
}

.p_box {
  height: 65px;
}

.p_box p {
  margin: 4px 0;
  transition: all 0.5s;
}

.p_box p:hover {
  color: #1557e0;
}
</style>